/*
 * @Author: yzr
 * @Date: 2020-12-02 16:02:41
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-02 16:02:42
 */
import TablePage from './table.vue';

export default TablePage;
